import { useEffect } from 'react';

export function useClickOutside(refs, handler) {
  useEffect(() => {
    const listener = event => {
      if (!refs) return;
      // Convert single ref to array for unified processing
      const refArray = Array.isArray(refs) ? refs : [refs];
      // portal check added: if portal exists, it means modal has some fields that have opened some popup,
      // so that should be closed first
      // that has open some popup so first that should be close
      const portalRoot = document.getElementById('portal-root'); // Assume this exists
      // Check if click is inside any of the ref elements
      const isInside = refArray.some(ref =>
        ref.current?.contains(event.target)
      );

      // If click is outside all refs, call handler
      if (!isInside && (!portalRoot || !portalRoot.contains(event.target))) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [refs, handler]);
}
